class ProductArchive {
  constructor() {
    this.downloadPdfBtn = jQuery('a.download-item.archive');

    // init
    this.downloadPdfBtn.removeClass('disabled');

    // bind events
    this.downloadPdfBtn.on('click', this.handleDownloadPDF.bind(this));
    jQuery('article.item.variable .format-selector select.format-select').on(
      'change',
      this.handleFormatSelectChange.bind(this)
    );
  }

  handleDownloadPDF(e) {
    e.preventDefault();
    const $this = jQuery(e.currentTarget);
    const category = $this.data('category');
    const loader = jQuery('.bb-loader-wrapper', $this);
    const offDiv = jQuery('.off', $this);
    const successDiv = jQuery('.success', $this);
    const errorDiv = jQuery('.error', $this);

    const handleDownloadPdfError = (error) => {
      console.error(error);
      $this.removeClass('state:success');
      $this.addClass('state:error');
      offDiv.hide();
      successDiv.hide();
      errorDiv.show();
      if (typeof Sentry !== 'undefined') {
        Sentry.captureException(error);
      }
    };

    getPriceList(category, '', true, {
      start: () => {
        loader.fadeIn(100);
        this.downloadPdfBtn.addClass('disabled');
      },

      success: (blob, filename) => {
        try {
          if (typeof saveAs === 'undefined') {
            return handleDownloadPdfError('saveAs is undefined!');
          }

          saveAs(blob, filename, {
            autoBom: true,
          });

          $this.removeClass('state:error');
          $this.addClass('state:success');

          offDiv.hide();
          errorDiv.hide();
          successDiv.show();
          this.downloadPdfBtn.off();

          setTimeout(() => {
            $this.removeClass('state:success');
            successDiv.hide();
            offDiv.show();

            jQuery(this.downloadPdfBtn).click((e) => {
              e.preventDefault();
              saveAs(blob, filename, {
                autoBom: true,
              });
            });
          }, 5000);
        } catch (error) {
          handleDownloadPdfError(error);
        }
      },

      error: (error) => {
        handleDownloadPdfError(error);
      },

      complete: () => {
        loader.fadeOut(100);
        this.downloadPdfBtn.removeClass('disabled');
      },
    });
  }

  handleFormatSelectChange(e) {
    e.preventDefault();
    const $this = jQuery(e.currentTarget);
    const $article = $this.parents('article.item');
    if ($article.length === 0) {
      return;
    }
    const variations = $article.data('variations');
    if (variations == null) {
      return;
    }
    const variationId = $this.val();
    const variation = variations[variationId];
    if (typeof variation === 'undefined') {
      return;
    }
    // urls
    const $urls = $article.find('[data-url]');
    $urls.attr('href', variation.url);

    // min qty
    const $minQty = $article.find('[data-min-qty]');
    $minQty.html(variation.min_qty);

    // price
    $article.find('.price-html').html(variation.price_html);
  }
}

jQuery(($) => new ProductArchive());
